export default {
    props: {
      effect: {
        type: String,
        default: 'fadein'
      }
    },
    data() {
      return {
        renderData: [],
        activeIndex: 0
      }
    },
    components: {
      'tablist': {
        inherit: true,
        template: `<li v-on="click:handleTablistClick($event,$index,this)"
        v-class="active:$index === activeIndex,
        disabled:disabled === true">
        <a href="#">
        {{{header}}}
        </a></li>`,
        methods: {
          handleTablistClick(e, index, el) {
            e.preventDefault()
            if (!el.disabled) this.activeIndex = index
          }
        },
      }
    }
  }


/** WEBPACK FOOTER **
 ** ./~/vue-loader/lib/selector.js?type=script&index=0!./src/Tabset.vue
 **/